import { CoffeeOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

const ComponentCoding: React.FC = () => {
    /**
     * Hooks
     */
    const { t } = useTranslation();

    return (
        <Space>
            <CoffeeOutlined />

            {t('developing')}
        </Space>
    );
};

export default ComponentCoding;
